import { BaseNomenclature } from "./baseNomenclature.model";

export class DosimeterPosition extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="dosimeter_position";
    }
}